module.exports = __webpack_public_path__ + "static/media/deskdude.4cce0048.svg";